import React from "react";
import styled from "styled-components";

const Stats = ({ totalIncome = 0, totalSpending = 0, currentTotal = 0 }) => {
  return (
    <StatsContainer>
      <Stat type="income">Total Income: ${totalIncome.toFixed(2)}</Stat>
      <Stat type="spending">Total Spending: ${totalSpending.toFixed(2)}</Stat>
      <Stat type="total">Current Total: ${currentTotal.toFixed(2)}</Stat>
    </StatsContainer>
  );
};

const StatsContainer = styled.div`
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 10px;
  text-align: left;
  font-size: 16px;
  width: 100%;
`;

const Stat = styled.p`
  margin: 0;
  padding: 5px 10px;
  border-left: 4px solid
    ${(props) =>
      props.type === "income"
        ? "green"
        : props.type === "spending"
        ? "red"
        : "blue"};
`;

export default Stats;
